import React, { useState, useRef } from 'react';
//import {  useHistory } from 'react-router-dom';
import Form, {
  Item,
  Label,
  ButtonItem,
  ButtonOptions,
  RequiredRule
} from 'devextreme-react/form';
import LoadIndicator from 'devextreme-react/load-indicator';
// import { useAuth } from '../../contexts/auth';
import { useDispatch } from "react-redux";
import * as authActions from '../../actions/authActions';
import './login-form.scss';

export default function (props) {
 // const history = useHistory();
  // const { logIn } = useAuth();
 // const auth = useSelector(state => state.auth);

  const dispatch = useDispatch();


  const [loading, ] = useState(false);
  const formData = useRef({});

  const onSubmit = (e) => {
    e.preventDefault();
    const { username, password } = formData.current;
   // console.log("aa");
    // setLoading(true);
    dispatch(authActions.login(username, password));
    // setLoading(false);

  };

  // const onCreateAccountClick = useCallback(() => {
  //   history.push('/create-account');
  // }, [history]);

  return (
    <form className={'login-form'} onSubmit={onSubmit}>
      <Form formData={formData.current} disabled={loading}>
        <Item
          dataField={'username'}
          editorType={'dxTextBox'}
          editorOptions={usernameEditorOptions}
        >
          <RequiredRule message="Username is required" />
          {/*<EmailRule message="Email is invalid" />*/}
          <Label visible={false} />
        </Item>
        <Item
          dataField={'password'}
          editorType={'dxTextBox'}
          editorOptions={passwordEditorOptions}
        >
          <RequiredRule message="Passwordaa is required" />
          <Label visible={false}  />
        </Item>
        {/* <Item
          dataField={'rememberMe'}
          editorType={'dxCheckBox'}
          editorOptions={rememberMeEditorOptions}
        >
          <Label visible={false} />
        </Item> */}
        <ButtonItem>
          <ButtonOptions
            width={'100%'}
            type={'default'}
            useSubmitBehavior={true}
          >
            <span className="dx-button-text">
              {
                loading
                  ? <LoadIndicator width={'24px'} height={'24px'} visible={true} />
                  : 'Sign In'
              }
            </span>
          </ButtonOptions>
        </ButtonItem>


      </Form>
    </form>
  );
}

const usernameEditorOptions = { stylingMode: 'filled', placeholder: 'Username', mode: 'text' };
const passwordEditorOptions = { stylingMode: 'filled', placeholder: 'Password', mode: 'password' };
//const rememberMeEditorOptions = { text: 'Remember me', elementAttr: { class: 'form-text' } };
